<div class="ImageLib">
  <div class="ImageLib-Item" *ngFor="let img of imgList; index as i">
    <img [src]="img" alt="" [class._selected]="selectedId === i" (click)="selected(img, i)">
  </div>
</div>
